import { BlobImage } from '@/components/blob/BlobImage';

import type { PanelArtifact } from '../../../../../bridge/types/messages.ts';

import { ContentArtifactIllustration } from './ContentArtifactIllustration.tsx';
import { MessageRow } from './MessageRow.tsx';

export const CarouselArtifactCard = ({
	message,
	onClick,
}: {
	message: PanelArtifact;
	onClick: () => void;
}) => {
	const title = message.title || 'New Instagram Carousel';
	const thumbnailUrl = message.icon_url;

	return (
		<MessageRow data-testid={`panel-artifact-${message.id}`}>
			<div className="flex w-full max-w-xs flex-col">
				<button
					type="button"
					onClick={onClick}
					className="glass-card-sm glass-card-hover group relative flex w-full
						cursor-pointer flex-col overflow-hidden text-left"
				>
					<div
						className="relative flex h-[120px] items-center justify-center
							overflow-hidden border-b border-[#F0F1F4] bg-[#F8F9FC]"
					>
						{thumbnailUrl ? (
							<BlobImage
								src={thumbnailUrl}
								alt=""
								className="absolute inset-0 size-full object-cover"
							/>
						) : (
							<>
								<div
									className="pointer-events-none absolute top-[-30px] left-[5%]
										h-[120px] w-[120px] rounded-full blur-[30px]"
									style={{ background: 'rgba(147,51,234,0.07)' }}
								/>
								<div
									className="pointer-events-none absolute top-[40px] left-[60%]
										h-[70px] w-[70px] rounded-full blur-[24px]"
									style={{ background: 'rgba(34,197,94,0.07)' }}
								/>
								<div className="relative z-10">
									<ContentArtifactIllustration type="post" />
								</div>
							</>
						)}
					</div>
					<div className="flex flex-col gap-1 px-5 pt-4 pb-5">
						<span
							className="text-[15px] leading-tight font-bold
								text-(--text-primary)"
						>
							{title}
						</span>
					</div>
				</button>
			</div>
		</MessageRow>
	);
};
